import { gql } from "@apollo/client";

export const SAVE_SORTING = gql`
    mutation saveSorting($data: CreateSortingInput!) {
        saveSorting(data: $data)
    }
`;

export default SAVE_SORTING;
